/* ============================================
   CAMPAIGN WIZARD BFE - TDTP
   ============================================

   Stapnavigatie en cart-calls voor de campagne-wizard.
   Gevuld in Task 3, 4, 5 en 6 (Autopictura-personalisatieformulier inline
   in stap 1, met guard tegen de dubbele variant-input; fix-ronde 1: submit
   pas los na gekozen ontwerp, fallback kan zichzelf weer verbergen;
   fix-ronde 2: gate-poll begrensd op ~60s, één functie beslist de
   knopstatus zodat de fout-afhandeling de gate niet meer kan omzeilen).

   FIX-RONDE whole-branch review:
   - I4: goToStep() verplaatst focus alleen nog bij een moveFocus=true
     aanroep — de boot-aanroep zet 'm op false, anders sprong de pagina bij
     elke landing over de hero heen naar de wizard (focus() op een
     tabindex="-1" element scrollt het element in beeld).
   - I5: resolveStartStep() landt weer OP een afgeronde meerkeuzestap
     (tegels/accessoires) i.p.v. eroverheen te springen; alleen een
     afgeronde ontwerpstap wordt nog overgeslagen.
   - I6: step.dataset.cwCompleted hernoemd naar cwStepDone
     (data-cw-step-done) — die botste met [data-cw-completed] op het
     JSON-script-blok in de sectie.
   - M3: aria-live aankondiging is nu per toevoeging uniek (producttitel
     erbij), zodat schermlezers 'm niet als ongewijzigd negeren.
   - M5: theme.js-regelverwijzing gecorrigeerd (25781 → 25803).

   RONDE 2 (terug-navigatie + kaarten uit-/aanzetten):
   - goToStep() houdt nu root.dataset.cwFurthest bij (de verst bereikte
     stap-index) en zet elke voortgangsknop met een lager of gelijk
     nummer vrij (disabled af). Terug gaan verlaagt cwFurthest nooit —
     alleen vooruit gaan kan 'm optrekken — dus eenmaal bereikte stappen
     blijven aanklikbaar in beide richtingen.
   - initCard() krijgt er een derde argument bij: cartLines, gelezen uit
     het nieuwe [data-cw-cart-lines] script-blok. Een kaart waarvan een
     eigen variant al in de cart ligt voor deze campagne/stap wordt meteen
     als toegevoegd getoond, MET de bijbehorende radio aangevinkt en de
     line-key opgeslagen — zodat een druk op de (nu "verwijderen")-knop
     precies die regel kan wegnemen.
   - De kaartknop is een toggle: niet-toegevoegd voegt toe (oude pad,
     ongewijzigd op de resolutie van de line-key na — die komt nu recht
     uit het /cart/add.js-antwoord i.p.v. herzocht in de volledige cart),
     toegevoegd verwijdert via /cart/change.js met { id: <line key>,
     quantity: 0 }. Dezelfde cw-busy-vlag beveiligt beide richtingen tegen
     een dubbele klik. Bij een mislukte verwijdering blijft de kaart in de
     toegevoegde staat — alleen de knop gaat weer open zodat de shopper
     het opnieuw kan proberen.
   - refreshNextLabel() gebruikt niet langer data-cw-step-done. Met kaarten
     die nu al bij het laden als toegevoegd gemarkeerd worden (zie hier-
     boven) is de telling [data-cw-card][data-cw-added] voor step_tiles/
     step_accessories vanaf boot() al correct. step_personalise heeft geen
     kaarten, dus de teller was daar altijd 0 — maar next/skip zijn voor
     die stap in alle zeven talen letterlijk dezelfde tekst (geverifieerd:
     en "Continue"/"Continue", nl "Verder"/"Verder", enzovoort), dus het
     wegvallen van de vlag verandert daar niets zichtbaars. Twee mecha-
     nismen voor hetzelfde signaal is dan overbodig; de tweede
     all.forEach-doorloop die de vlag zette is meteen mee weg.

   RONDE B (styling-feedback klant):
   - cardVariantIds/initCard lezen nu een <select data-cw-variant-select>
     i.p.v. een NodeList radio's. Eén 'change'-listener op de select i.p.v.
     één per radio; de rest van de add/remove-logica (setCardAdded,
     findCardLine) verandert niet — die werkte al op variant-id's, niet op
     het inputtype.
   - goToStep() zet nu ook de vulling van de decoratieve voortgangsbalk
     (progress_style: bar — zie [data-cw-progress-bar-fill]) en schrijft
     cwFurthest naar localStorage weg (readFurthest/writeFurthest/
     clearFurthest, zelfde SKIP_PREFIX-recept als de skips). Dat lost op
     dat cwFurthest tot nu toe alleen in het DOM-dataset leefde: een
     herlaadde pagina begon weer bij furthest=0, dus een al bereikte stap
     stond na een refresh weer op slot en resolveStartStep kon op een
     eerdere stap landen dan de shopper al had gezien. boot() leest de
     opgeslagen furthest nu terug en neemt Math.max(stored, landingIndex)
     vóór de eerste goToStep-aanroep. clearFurthest hangt aan dezelfde
     voorwaarde als clearSkips (lege cart voor deze campagne) zodat de
     waarde nooit een leeggemaakt mandje overleeft.

   RONDE B FIXRONDE (Critical 2 — placeholder-gate lekte):
   - De 'change'-listener op de select in initCard() liet bij het opnieuw
     kiezen van de placeholder (value="") gewoon return doen zonder de
     opgeslagen addBtn.dataset.cwVariantId te wissen of de knop weer dicht
     te zetten. De select toonde dan "Kies een optie" terwijl een klik op
     de nog-steeds-actieve knop alsnog de vorige, niet meer zichtbare
     variant toevoegde. Gefixt: leeg value -> dataset.cwVariantId gewist +
     knop disabled, exact het omgekeerde van een echte keuze.
   - setCardAdded() zet de select nu zelf op `disabled` zolang de kaart
     'toegevoegd' is (en maakt 'm weer los bij het verwijderen). De knop
     werkt in toegevoegd-modus altijd via de opgeslagen line-key, nooit via
     een variant-id — door de select in die modus te locken kan er nooit
     een moment ontstaan waarop select-waarde en knop-target uiteenlopen,
     i.p.v. dat apart te moeten bewaken. Gevolg: de 'change'-listener in
     initCard() hoeft niet meer op card.dataset.cwAdded te checken (kan
     toch niet vuren zolang de select disabled staat) en is nu de ENE plek
     die addBtn's target-variant en enabled-status bepaalt — zelfde
     eigendomsmodel als applyGateState() bij het personalisatieformulier.

   RONDE B FIXRONDE 2 (headline-bug: knop bleef dood na een geslaagde
   verwijdering — het toggle-gedrag dat deze hele ronde vroeg was half
   kapot):
   - Nieuwe functie applyCardButtonState(card, addBtn, variantSelect) is nu
     de ENE plek die addBtn's disabled-attribuut EN data-cw-variant-id zet.
     setCardAdded() delegeert er zelf naar i.p.v. los addBtn.removeAttribute
     ('disabled') te doen; de select-'change'-listener en de busy-lock/
     fail-revert-code in de click-handler (initCard) zijn ook omgezet — geen
     directe write naar addBtn.disabled of addBtn.dataset.cwVariantId meer
     buiten deze functie.
   - Root cause van de bug: bij een geslaagde remove riep alleen
     setCardAdded(..., false, ...) — dat zette ooit "knop dicht tenzij er al
     een dataset.cwVariantId stond", en die stond na een eerdere toevoeging
     altijd nog steeds klaar, dus de oude regel deed feitelijk niets: de
     knop bleef op het moment van de fix nog steeds hangen op de disabled-
     stand die de busy-lock aan het begin van de click had gezet. Nu roept
     de click-handler applyCardButtonState() opnieuw aan NA het terugzetten
     van cwBusy op 'false' (in de laatste .then() van zowel het add- als het
     remove-pad) — die aanroep is de beslissende, want de tussentijdse
     aanroep vanuit setCardAdded() gebeurt nog terwijl cwBusy 'true' is.
   - De volgorde van feiten in applyCardButtonState (busy > toegevoegd >
     select-waarde > vaste variant-id) is beschreven bij de functie zelf.

   RONDE C (feedback Bram 15-09-2026):
   - Geen auto-doorgaan meer na het toevoegen van de gepersonaliseerde
     tegel. De flow is nu op elke stap hetzelfde: eerst toevoegen, dan
     verschijnt de verder-knop. Zolang er niets is toegevoegd staat er
     alleen een subtiele overslaan-link ([data-cw-skip]).
     refreshActions() vervangt refreshNextLabel(): het wisselt geen tekst
     meer, maar zichtbaarheid (knop ↔ link). Op de laatste stap staat de
     knop er altijd.
   - stepHasAdditions() is de ENE plek die bepaalt of een stap iets heeft
     toegevoegd: kaarten met data-cw-added, of voor de ontwerpstap
     step.dataset.cwPersoAdded (gezet door setPersoAdded, bij toevoegen of
     bij het laden als de cart al een step_personalise-regel heeft).
   - applyGateState() zet alleen nog disabled, geen tekst. Het wisselende
     label "Kies eerst je ontwerp" las als knop en verwarde.
   - goToStep() zet ook de vulling van de stepper-lijn
     ([data-cw-progress-line-fill]): (index-1)/(n-1), zodat de lijn precies
     tot het huidige bolletje loopt.

   RONDE D (feedback Bram 22-09-2026): maatkeuze in de ontwerpstap
   (initPersoVariant) en "Add another personal tile" (initPersoAgain +
   ?cw_again=1 in boot).

   Versie: 1.4 - 22-09-2026
   ============================================ 
   RONDE F (feedback Bram 29-09-2026):
   - Aantal-stepper op kaarten + ontwerpstap (initQty, setQty/clampQty).
     Toevoegen neemt het aantal mee. Na toevoegen staat de stepper op slot
     (setCardAdded) en gaat pas weer open na verwijderen (feedback Bram).
   - Rail met pijlen voor tegels/accessoires (initRail); desktop = één rij.
   - goToStep scrollt de wizard bovenaan in beeld bij een stapwissel.
*/

(function () {
  'use strict';

  var CART = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';

  function fetchCart() {
    return fetch(CART + '.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* Toevoegen ZONDER de cart-drawer te openen.

     Pipeline's eigen add-knop roept handleSuccess aan, die de drawer opent
     via theme:drawer:open (theme.js ~25803). Wij slaan dat pad bewust over:
     tijdens de wizard moet de drawer dicht blijven. De twee events hieronder
     zijn genoeg om de header-teller en de cart-inhoud bij te werken —
     hetzelfde patroon als cart-rewards-bfe.js.

     Antwoord: { cart: <volledige cart>, key: <line-key van de zojuist
     toegevoegde regel, of null> }. De key komt rechtstreeks uit het
     /cart/add.js-antwoord (dat bij een los object, niet een items-array, de
     toegevoegde regel zelf teruggeeft inclusief zijn eigen key) — preciezer
     dan 'm achteraf terugzoeken in de volledige cart op variant-id, wat
     dubbelzinnig is zodra dezelfde variant met andere properties al eens
     is toegevoegd. */
  function addToCart(variantId, stepType, campaignHandle, quantity) {
    var body = {
      id: Number(variantId),
      /* RONDE F: aantal uit de stepper op de kaart (standaard 1) */
      quantity: Math.max(1, Number(quantity) || 1),
      properties: {
        _cw_campaign: campaignHandle,
        _cw_step: stepType
      }
    };

    var addedKey = null;

    return fetch(CART + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().then(function (data) {
          var err = new Error('cart-add-failed');
          err.description = data && data.description;
          throw err;
        });
      })
      .then(function (addedItem) {
        addedKey = addedItem && addedItem.key;
        return fetchCart();
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart }, bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        return { cart: cart, key: addedKey };
      });
  }

  /* Regel verwijderen via de line-key (niet de variant-id — dezelfde
     variant kan met andere properties meerdere keren in de cart staan, dan
     is variant-id dubbelzinnig). /cart/change.js antwoordt zelf al met de
     volledige, bijgewerkte cart (anders dan /cart/add.js, dat alleen de
     betrokken regel teruggeeft), dus geen aparte fetchCart()-aanroep nodig.
     Zelfde twee events als addToCart, en NOOIT theme:drawer:open — de
     drawer blijft dicht zolang de wizard loopt. */
  function removeFromCart(lineKey) {
    return fetch(CART + '/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().then(function (data) {
          var err = new Error('cart-remove-failed');
          err.description = data && data.description;
          throw err;
        });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart }, bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        return cart;
      });
  }

  /* RONDE F: aantal-stepper (snippets/campaign-wizard-qty-bfe.liquid).
     Eén gedelegeerde handler voor de hele wizard: ±1 via de knoppen, en de
     invoer altijd terug naar een heel getal tussen 1 en 99. Na elke
     wijziging een 'cw:qty'-event op het input (haakje voor uitbreiding; de
     kaart leest het aantal zelf uit bij toevoegen). */
  var QTY_MIN = 1;
  var QTY_MAX = 99;

  function clampQty(value) {
    var n = parseInt(value, 10);
    if (isNaN(n)) n = QTY_MIN;
    return Math.min(QTY_MAX, Math.max(QTY_MIN, n));
  }

  function setQty(input, value, notify) {
    var n = clampQty(value);
    var changed = String(input.value) !== String(n);
    input.value = n;
    if (notify && changed) input.dispatchEvent(new CustomEvent('cw:qty', { bubbles: true }));
  }

  function initQty(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-cw-qty-step]');
      if (!btn || !root.contains(btn)) return;
      var input = btn.closest('[data-cw-qty]').querySelector('[data-cw-qty-input]');
      if (!input || input.disabled || btn.disabled) return;
      setQty(input, clampQty(input.value) + Number(btn.dataset.cwQtyStep), true);
    });
    root.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('[data-cw-qty-input]')) return;
      e.target.value = clampQty(e.target.value);
      e.target.dispatchEvent(new CustomEvent('cw:qty', { bubbles: true }));
    });
  }

  /* RONDE F: rail met pijlen voor tegels/accessoires. Op desktop maakt de
     CSS van het raster één horizontale rij; alleen dán zijn er pijlen nodig.
     Knoppen verbergen zich als er niets te schuiven valt (mobiel-raster of
     weinig producten) en gaan dicht aan het begin/einde van de rij. */
  function initRail(rail) {
    var grid = rail.querySelector('[data-cw-grid]');
    var prev = rail.querySelector('[data-cw-rail-prev]');
    var next = rail.querySelector('[data-cw-rail-next]');
    if (!grid || !prev || !next) return;

    function update() {
      var scrollable = grid.scrollWidth > grid.clientWidth + 2;
      prev.hidden = !scrollable;
      next.hidden = !scrollable;
      if (!scrollable) return;
      prev.disabled = grid.scrollLeft <= 2;
      next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
    }

    function page(direction) {
      grid.scrollBy({ left: direction * grid.clientWidth * 0.8, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    rail.cwRailUpdate = update;
    update();
  }

  function announce(root, message) {
    var live = root.querySelector('[data-cw-live]');
    if (live) live.textContent = message;
  }

  /* [data-cw-cart-lines] uit de sectie: per cart-regel van deze campagne
     { step, variant_id, key }. Leeg bij een lege cart of een gooiende
     parse — dan toont geen enkele kaart zich als toegevoegd, wat het
     juiste resultaat is (er valt niets te tonen). */
  function readCartLines(root) {
    var el = root.querySelector('[data-cw-cart-lines]');
    if (!el) return [];
    try {
      var lines = JSON.parse(el.textContent);
      return Array.isArray(lines) ? lines : [];
    } catch (e) {
      return [];
    }
  }

  /* Alle variant-id's die deze kaart zou kunnen toevoegen: bij een
     variantkeuze elke niet-lege <option>-waarde van de select (RONDE B:
     was een NodeList radio's, de placeholder-option met value="" telt
     bewust niet mee), anders (variant_count === 1) de vaste
     data-cw-variant-id op de knop zelf. */
  function cardVariantIds(card) {
    var select = card.querySelector('[data-cw-variant-select]');
    if (select) {
      return Array.prototype.filter.call(select.options, function (opt) { return opt.value; })
        .map(function (opt) { return String(opt.value); });
    }
    var addBtn = card.querySelector('[data-cw-add]');
    return addBtn && addBtn.dataset.cwVariantId ? [String(addBtn.dataset.cwVariantId)] : [];
  }

  /* Eerste cart-regel van deze stap waarvan de variant bij deze kaart
     hoort. step moet overeenkomen (dezelfde variant kan in theorie in een
     andere stap zitten) en de variant-id moet een van de kaart z'n eigen
     variant-id's zijn. */
  function findCardLine(card, step, lines) {
    if (!step) return null;
    var ids = cardVariantIds(card);
    if (!ids.length) return null;
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (line.step !== step.dataset.cwStep) continue;
      if (ids.indexOf(String(line.variant_id)) !== -1) return line;
    }
    return null;
  }

  /* RONDE B fixronde 2 (headline-bug: knop bleef dood na een geslaagde
     verwijdering). ENIGE plek die addBtn's disabled-attribuut en
     data-cw-variant-id zet — analoog aan applyGateState() bij het
     personalisatieformulier. Elk pad (boot met kaart al in de cart, add
     geslaagd/mislukt, remove geslaagd/mislukt, select-wijziging, en de
     busy-lock die een dubbelklik voorkomt) roept dit aan i.p.v. zelf aan
     disabled of data-cw-variant-id te zitten — dat is precies wat eerder
     misging: setCardAdded zette de knop bij een geslaagde add/boot-match
     los, maar bij een geslaagde REMOVE deed niets dat opnieuw voor een
     kaart met een select (dataset.cwVariantId bleef nog gewoon staan van
     vóór de toevoeging, dus de oude "alleen setten als er nog geen
     dataset.cwVariantId was"-regel deed niets).

     Volgorde van de feiten, hoogste prioriteit eerst:
     1. addBtn.dataset.cwBusy === 'true' -> een add/remove-call loopt al:
        altijd dicht, ongeacht de rest. Dit vervangt de losse
        addBtn.setAttribute('disabled', ...) die vroeger direct in de
        click-handler stond bij het starten van een call.
     2. card.dataset.cwAdded === 'true' -> remove-modus: de knop werkt
        altijd via de opgeslagen line-key, nooit via een variant-id, dus
        altijd klikbaar (zolang niet ook busy).
     3. Anders (add-modus): met een select telt alleen een echte
        (niet-placeholder) waarde als geldige variant — leeg -> knop dicht
        + data-cw-variant-id gewist (Critical 2: nooit een oude, niet meer
        zichtbare variant laten hangen). Zonder select (variant_count===1)
        blijft de vaste data-cw-variant-id die Liquid al zette leidend. */
  function applyCardButtonState(card, addBtn, variantSelect) {
    if (addBtn.dataset.cwBusy === 'true') {
      addBtn.setAttribute('disabled', 'disabled');
      return;
    }

    if (card.dataset.cwAdded === 'true') {
      addBtn.removeAttribute('disabled');
      return;
    }

    if (variantSelect) {
      if (variantSelect.value) {
        addBtn.dataset.cwVariantId = variantSelect.value;
        addBtn.removeAttribute('disabled');
      } else {
        delete addBtn.dataset.cwVariantId;
        addBtn.setAttribute('disabled', 'disabled');
      }
      return;
    }

    if (addBtn.dataset.cwVariantId) {
      addBtn.removeAttribute('disabled');
    } else {
      addBtn.setAttribute('disabled', 'disabled');
    }
  }

  /* Enige plek die de toegevoegd/niet-toegevoegd-status van een kaart
     zet — label en dataset lopen zo nooit uiteen, of de aanroep nu van een
     succesvolle add, een succesvolle remove, of de cart-match bij boot()
     komt. Knopstatus zelf (disabled/target-variant) delegeert altijd naar
     applyCardButtonState() hierboven.

     RONDE B fixronde (Critical 2): de select wordt hier ook op slot gezet
     zolang de kaart 'toegevoegd' is. De knop werkt in die stand ALTIJD via
     de opgeslagen line-key (card.dataset.cwLineKey), nooit via een
     variant-id — een select-wijziging zou dus alleen de getoonde prijs
     kunnen laten afwijken van de variant die echt in de cart ligt, zonder
     dat de verwijderknop daar iets mee doet. Door de select native disabled
     te zetten kán die divergentie niet ontstaan (geen change-events, geen
     aparte "wat als de select toch wijzigt terwijl toegevoegd"-tak nodig)
     i.p.v. dat apart te moeten bijhouden. De shopper moet eerst verwijderen
     — dan gaat de select weer open — voor hij een andere maat kiest. Dit is
     nu ook de ENIGE plek die de select's disabled-status zet; de
     'change'-listener in initCard() hoeft daar dus niet meer op te
     controleren (kan sowieso niet vuren zolang de select disabled is). */
  /* RONDE F: aantal-stepper op slot zolang de kaart in de cart ligt; pas na
     verwijderen weer open. Zelfde reden als de select hierboven: wat er in
     de cart ligt en wat de kaart toont mogen niet uit elkaar lopen. */
  function setQtyLocked(card, locked) {
    Array.prototype.forEach.call(
      card.querySelectorAll('[data-cw-qty-input], [data-cw-qty-step]'),
      function (el) {
        if (locked) el.setAttribute('disabled', 'disabled');
        else el.removeAttribute('disabled');
      }
    );
  }

  function setCardAdded(card, addBtn, labelEl, added, lineKey) {
    var variantSelect = card.querySelector('[data-cw-variant-select]');
    setQtyLocked(card, added);
    if (added) {
      card.dataset.cwAdded = 'true';
      if (lineKey) card.dataset.cwLineKey = String(lineKey);
      if (labelEl) labelEl.textContent = labelEl.dataset.cwLabelRemove;
      if (variantSelect) variantSelect.setAttribute('disabled', 'disabled');
    } else {
      delete card.dataset.cwAdded;
      delete card.dataset.cwLineKey;
      if (labelEl) labelEl.textContent = labelEl.dataset.cwLabelAdd;
      if (variantSelect) variantSelect.removeAttribute('disabled');
    }
    if (addBtn) applyCardButtonState(card, addBtn, variantSelect);
  }

  function initCard(card, root, cartLines) {
    var addBtn = card.querySelector('[data-cw-add]');
    if (!addBtn) return;

    var variantSelect = card.querySelector('[data-cw-variant-select]');
    var priceEl = card.querySelector('[data-cw-price]');
    var errorEl = card.querySelector('[data-cw-error]');
    var labelEl = card.querySelector('[data-cw-add-label]');
    var qtyInput = card.querySelector('[data-cw-qty-input]');
    var step = card.closest('[data-cw-step]');

    /* RONDE B fixronde 2: deze listener roept nu enkel applyCardButtonState()
       aan i.p.v. zelf aan disabled/data-cw-variant-id te zitten — dat is de
       ENE beslisser, zie de toelichting daar. Kan sowieso alleen vuren in
       add-modus: setCardAdded() zet de select zelf disabled zolang de
       kaart 'toegevoegd' is. */
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        applyCardButtonState(card, addBtn, variantSelect);
        var selectedOption = variantSelect.options[variantSelect.selectedIndex];
        if (priceEl && selectedOption && selectedOption.dataset.cwVariantPrice) {
          priceEl.textContent = selectedOption.dataset.cwVariantPrice;
        }
      });
    }

    /* Kaart die volgens de cart al bij deze campagne/stap hoort meteen als
       toegevoegd tonen, mét de bijbehorende optie geselecteerd zodat een
       eventuele undo-en-opnieuw-toevoegen dezelfde variant pakt zonder dat
       de shopper 'm opnieuw hoeft te kiezen. De select-waarde wordt hier
       gezet (dat is een eigenschap van de select zelf, geen knopstatus);
       addBtn.dataset.cwVariantId raakt setCardAdded()'s aanroep van
       applyCardButtonState() vanzelf aan — geen directe write hier meer. */
    var existingLine = findCardLine(card, step, cartLines);
    if (existingLine) {
      var matchedOption = null;
      if (variantSelect) {
        Array.prototype.forEach.call(variantSelect.options, function (opt) {
          if (opt.value && String(opt.value) === String(existingLine.variant_id)) matchedOption = opt;
        });
      }
      if (matchedOption) {
        variantSelect.value = matchedOption.value;
        if (priceEl && matchedOption.dataset.cwVariantPrice) {
          priceEl.textContent = matchedOption.dataset.cwVariantPrice;
        }
      }
      if (qtyInput && existingLine.quantity) setQty(qtyInput, existingLine.quantity, false);
      setCardAdded(card, addBtn, labelEl, true, existingLine.key);
    }

    addBtn.addEventListener('click', function () {
      if (addBtn.dataset.cwBusy === 'true') return;

      /* Toegevoegd -> knop verwijdert i.p.v. toevoegt. Zelfde cw-busy-vlag
         als de add-kant, dus een dubbelklik kan nooit twee verwijder-calls
         (of een add en een remove tegelijk) afvuren. Elke disabled-write
         hieronder loopt via applyCardButtonState() — geen directe
         addBtn.setAttribute/removeAttribute('disabled') meer in deze
         handler. */
      if (card.dataset.cwAdded === 'true') {
        var lineKey = card.dataset.cwLineKey;
        if (!lineKey) return;

        addBtn.dataset.cwBusy = 'true';
        applyCardButtonState(card, addBtn, variantSelect);
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

        removeFromCart(lineKey)
          .then(function () {
            /* HEADLINE-FIX: setCardAdded(..., false, ...) zet card.dataset.cwAdded
               los en de select weer open, en roept zelf applyCardButtonState()
               aan — maar op dát moment staat cwBusy nog op 'true' (die wordt
               pas hieronder, in de laatste .then(), teruggezet), dus die
               tussentijdse aanroep houdt de knop nog dicht. Pas de LAATSTE
               applyCardButtonState()-aanroep hieronder (na cwBusy = 'false')
               is beslissend: busy is dan false, added is dan false, en de
               select staat nog op de net-verwijderde variant -> knop gaat
               weer open, meteen klaar om opnieuw toe te voegen. Vóór deze
               fixronde deed niets dat: de knop bleef dood staan na een
               geslaagde verwijdering. */
            setCardAdded(card, addBtn, labelEl, false, null);
            if (qtyInput) setQty(qtyInput, 1, false);
            card.dispatchEvent(new CustomEvent('cw:removed', { bubbles: true }));
          })
          .catch(function (err) {
            /* Faalpad: kaart blijft in de toegevoegde status — alleen de
               knop weer vrijgeven (via de laatste applyCardButtonState()-
               aanroep hieronder) zodat de shopper het opnieuw kan proberen.
               dataset.cwAdded/cwLineKey blijven ongemoeid. Eigen fallback-
               tekst (cwLabelRemoveFailed, niet cwLabelFailed — die laatste
               zegt "kon niet toevoegen", verkeerd bericht voor een
               mislukte verwijdering). */
            if (errorEl) {
              errorEl.textContent = err.description || root.dataset.cwLabelRemoveFailed;
              errorEl.hidden = false;
            }
          })
          .then(function () {
            addBtn.dataset.cwBusy = 'false';
            applyCardButtonState(card, addBtn, variantSelect);
          });
        return;
      }

      var variantId = addBtn.dataset.cwVariantId;
      if (!variantId) return;

      /* Op slot tot de call terug is: dubbelklikken zou anders twee regels
         opleveren voor één bedoelde toevoeging. */
      addBtn.dataset.cwBusy = 'true';
      applyCardButtonState(card, addBtn, variantSelect);
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

      addToCart(variantId, step.dataset.cwStep, root.dataset.campaignHandle, qtyInput ? clampQty(qtyInput.value) : 1)
        .then(function (result) {
          setCardAdded(card, addBtn, labelEl, true, result.key);
          /* M3: card.dataset.cwAnnounce bevat de kaart-eigen aankondiging
             mét producttitel (uit Liquid, via de t-filter). Zonder dat
             attribuut valt terug op de generieke tekst. */
          announce(root, card.dataset.cwAnnounce || root.dataset.cwLabelAnnounce);
          card.dispatchEvent(new CustomEvent('cw:added', { bubbles: true }));
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = err.description || root.dataset.cwLabelFailed;
            errorEl.hidden = false;
          }
        })
        .then(function () {
          addBtn.dataset.cwBusy = 'false';
          applyCardButtonState(card, addBtn, variantSelect);
        });
    });
  }

  function steps(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-cw-step]'));
  }

  /* moveFocus: alleen bij een echte, door de klant veroorzaakte stapwissel
     mag de focus (en dus de scrollpositie — focus() op een tabindex="-1"
     element scrollt het in beeld) verspringen naar de kop van de nieuwe
     stap. De boot-aanroep (initiële weergave/hervatten na herladen) geeft
     hier bewust false door: anders springt de pagina bij elke landing over
     de hero heen naar de wizard. Bij een echte stapwissel blijft moveFocus
     wél true — dat is precies wat schermlezergebruikers meeneemt. */
  function goToStep(root, index, moveFocus) {
    var all = steps(root);
    all.forEach(function (step) {
      var isActive = Number(step.dataset.cwIndex) === index;
      step.hidden = !isActive;
      if (isActive && moveFocus) {
        var heading = step.querySelector('.campaign-wizard-bfe__step-heading');
        /* Focus naar de kop zodat een schermlezer de stapwissel meekrijgt.
           Zonder dit blijft de focus op de verder-knop van de vorige stap,
           die inmiddels verborgen is. */
        /* RONDE F: preventScroll + de wizard zelf bovenaan in beeld
           (scroll-margin-top houdt rekening met de sticky header). Zonder
           dit bleef de shopper halverwege de vorige, langere stap staan. */
        if (heading) heading.focus({ preventScroll: true });
        var top = root.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.3) {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      /* Een verborgen rail had breedte 0; na tonen de pijlen opnieuw meten. */
      if (isActive) {
        Array.prototype.forEach.call(step.querySelectorAll('[data-cw-rail]'), function (rail) {
          if (rail.cwRailUpdate) window.requestAnimationFrame(rail.cwRailUpdate);
        });
      }
    });

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-cw-progress-item]'),
      function (item) {
        var n = Number(item.dataset.cwProgressItem);
        if (n === index) {
          item.setAttribute('aria-current', 'step');
        } else {
          item.removeAttribute('aria-current');
        }
        if (n < index) {
          item.dataset.cwDone = 'true';
        } else {
          delete item.dataset.cwDone;
        }
      }
    );

    /* RONDE 2: de verst bereikte stap staat vast op root, ongeacht welke
       kant de shopper nu op gaat. Alleen VOORUIT trekt 'm op; teruggaan
       naar een eerdere stap mag een al bereikte stap nooit weer op slot
       zetten. Elke voortgangsknop tot en met cwFurthest wordt vrijgegeven
       — dat is precies "al bereikt, dus terug-klikbaar".

       RONDE B: cwFurthest wordt hier ook naar localStorage geschreven
       (writeFurthest) — bij elke aanroep, niet alleen als de waarde
       omhoog gaat, zodat de opslag nooit kan afwijken van het dataset.
       Zonder die opslag verdween cwFurthest bij een herlaadpagina: boot()
       begon dan weer bij furthest=0 en een al bereikte stap stond na een
       refresh weer op slot (zie RONDE B in boot() hieronder). */
    var furthest = Number(root.dataset.cwFurthest || 0);
    if (index > furthest) {
      furthest = index;
      root.dataset.cwFurthest = String(furthest);
    }
    writeFurthest(root.dataset.campaignHandle, furthest);

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-cw-progress-button]'),
      function (btn) {
        btn.disabled = Number(btn.dataset.cwProgressButton) > furthest;
      }
    );

    /* RONDE B: decoratieve voortgangsbalk (progress_style: bar) — puur een
       CSS-vulling die de <ol> hierboven volgt, geen eigen stap-status. Geen
       querySelector-kosten van belang: dit element bestaat alleen als de
       sectie-instelling 'bar' is, anders is de query gewoon leeg. */
    var barFill = root.querySelector('[data-cw-progress-bar-fill]');
    if (barFill) {
      var pct = all.length ? Math.round((index / all.length) * 100) : 0;
      barFill.style.width = pct + '%';
    }

    /* RONDE C: stepper-lijn. Loopt van het midden van bolletje 1 tot het
       midden van het laatste, dus op stap 1 leeg en op de laatste stap vol. */
    var lineFill = root.querySelector('[data-cw-progress-line-fill]');
    if (lineFill) {
      var linePct = all.length > 1 ? Math.round(((index - 1) / (all.length - 1)) * 100) : 0;
      lineFill.style.width = linePct + '%';
    }

    root.dataset.cwCurrent = String(index);
  }

  /* Het label van de verder-knop volgt wat de klant in deze stap heeft
     gedaan: zonder selectie is doorgaan hetzelfde als overslaan, en dan
     moet de knop dat ook zeggen. Zo is overslaan nooit een aparte keuze
     die de klant actief moet afwijzen.

     RONDE 2: gebruikt niet langer data-cw-step-done (I6). Kaarten worden nu
     al bij boot() als toegevoegd gemarkeerd zodra hun variant in de cart
     zit (zie initCard/findCardLine), dus de telling hieronder is voor
     step_tiles/step_accessories vanaf het begin correct — de aparte vlag
     was er alleen om diezelfde correctie te forceren voordat kaarten dat
     zelf konden. step_personalise heeft geen kaarten (telt dus altijd 0),
     maar next- en skip-tekst zijn voor die stap in alle zeven talen
     identiek, dus dat heeft nooit zichtbaar gemaakt welke van de twee
     branches won. Eén mechanisme volstaat. */
  function stepHasAdditions(step) {
    if (step.dataset.cwPersoAdded === 'true' || step.dataset.cwPersoHas === 'true') return true;
    return step.querySelectorAll('[data-cw-card][data-cw-added]').length > 0;
  }

  /* RONDE C: vervangt refreshNextLabel. Zichtbaarheid i.p.v. tekst:
     toegevoegd → verder-knop, niets toegevoegd → overslaan-link. De laatste
     stap heeft geen link en toont de knop altijd, want afronden mag nooit
     achter een subtiele link verstopt zitten. */
  function refreshActions(step) {
    var next = step.querySelector('[data-cw-next]');
    var skip = step.querySelector('[data-cw-skip]');

    if (step.hasAttribute('data-cw-last')) {
      if (next) next.hidden = false;
      return;
    }

    var added = stepHasAdditions(step);
    if (next) next.hidden = !added;
    if (skip) skip.hidden = added;
  }

  /* RONDE C: de ontwerpstap is klaar. Submit weg (geen tweede tegel via
     deze knop), bevestiging erin. Aangeroepen na een geslaagde toevoeging
     én bij het laden als de cart al een step_personalise-regel voor deze
     campagne heeft. */
  function setPersoAdded(step) {
    if (!step) return;
    step.dataset.cwPersoAdded = 'true';
    var submit = step.querySelector('[data-cw-perso-submit]');
    var note = step.querySelector('[data-cw-perso-added]');
    var again = step.querySelector('[data-cw-perso-again]');
    /* RONDE F: de hele rij (aantal + knop) verbergen, niet alleen de knop —
       anders bleef het stepje los boven de bevestiging staan. */
    var buyRow = step.querySelector('[data-cw-perso-buy]');
    if (buyRow) buyRow.hidden = true;
    if (submit) submit.hidden = true;
    if (note) note.hidden = false;
    if (again) again.hidden = false;
  }

  /* RONDE D: maatkeuze in de ontwerpstap. De select schrijft in de
     verborgen input[name="id"] (die guardVariantInput beschermt) en werkt
     prijs + maatinfo bij. Zonder select (product met één variant) doet
     dit niets. */
  function initPersoVariant(form) {
    var select = form.querySelector('[data-cw-perso-variant]');
    var input = form.querySelector('input[name="id"][data-theme-variant-input]');
    var price = form.querySelector('[data-cw-perso-price]');
    var info = form.querySelector('[data-cw-perso-size-info]');
    if (!select || !input) return;

    function apply() {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      input.value = opt.value;
      if (price && opt.getAttribute('data-cw-variant-price')) {
        price.textContent = opt.getAttribute('data-cw-variant-price');
      }
      if (info) {
        var text = opt.getAttribute('data-cw-size-info') || '';
        info.textContent = text;
        info.hidden = !text;
      }
    }

    select.addEventListener('change', apply);
    apply();
  }

  /* RONDE D: nog een fototegel met een ander ontwerp. Autopictura heeft
     geen reset, dus herladen we met ?cw_again=1. boot() ziet die parameter,
     start op de ontwerpstap in de begin-stand en haalt 'm uit de URL. */
  var AGAIN_PARAM = 'cw_again';

  function initPersoAgain(step) {
    var again = step && step.querySelector('[data-cw-perso-again]');
    if (!again) return;
    again.addEventListener('click', function () {
      var url = new URL(window.location.href);
      url.searchParams.set(AGAIN_PARAM, '1');
      url.hash = 'campagne';
      window.location.assign(url.toString());
    });
  }

  function consumeAgainParam() {
    var url;
    try { url = new URL(window.location.href); } catch (e) { return false; }
    if (url.searchParams.get(AGAIN_PARAM) !== '1') return false;
    url.searchParams.delete(AGAIN_PARAM);
    try { window.history.replaceState(window.history.state, '', url.toString()); } catch (e) { /* niet fataal */ }
    return true;
  }

  function finish(root) {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) {
      window.location.href = CART;
      return;
    }

    /* Op slot tot de cart-fetch terug is: een tweede klik terwijl we al
       aan het ophalen zijn mag geen tweede drawer-open (of een race
       tussen twee fetches) veroorzaken. Zelfde patroon als data-cw-busy
       op de kaart. */
    if (root.dataset.cwFinishing === 'true') return;
    root.dataset.cwFinishing = 'true';

    /* Eerst verse cart-data ophalen en pas dán de drawer openen. Pipeline's
       eigen instant-drawer pad (theme.js, handleSuccess) wacht ook op
       cartReady vóórdat het de drawer opent — zonder die wacht toont de
       drawer een fractie van een seconde de oude (leeg of verouderde)
       inhoud. Dat is precies het moment waar de hele wizard naartoe werkt:
       de shopper ziet hier voor het eerst alles wat hij verzameld heeft,
       dus die flits mag er niet zijn. */
    fetchCart()
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart }, bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
      })
      .catch(function () {
        /* Cart-data kon niet opgehaald worden: de shopper mag niet
           vastlopen op een dode knop op de laatste stap, dus dan alsnog
           naar de cart-pagina. */
        window.location.href = CART;
      })
      .then(function () {
        root.dataset.cwFinishing = 'false';
      });
  }

  var SKIP_PREFIX = 'cw-skips-';

  /* localStorage kan gooien in privémodus of met geblokkeerde site-data.
     Zonder opgeslagen skips werkt de wizard gewoon door; de klant komt dan
     alleen op een stap die hij eerder oversloeg. */
  function readSkips(handle) {
    try {
      var raw = window.localStorage.getItem(SKIP_PREFIX + handle);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeSkip(handle, stepType) {
    try {
      var skips = readSkips(handle);
      if (skips.indexOf(stepType) === -1) skips.push(stepType);
      window.localStorage.setItem(SKIP_PREFIX + handle, JSON.stringify(skips));
    } catch (e) {
      /* stil: skips zijn een gemak, geen voorwaarde */
    }
  }

  function clearSkips(handle) {
    try {
      window.localStorage.removeItem(SKIP_PREFIX + handle);
    } catch (e) {}
  }

  /* RONDE B: zelfde recept als de skips hierboven, voor de verst bereikte
     stap (root.dataset.cwFurthest). Zonder deze opslag verdween cwFurthest
     bij een herlaadpagina — zie de toelichting in goToStep() en boot(). */
  var FURTHEST_PREFIX = 'cw-furthest-';

  function readFurthest(handle) {
    try {
      var raw = window.localStorage.getItem(FURTHEST_PREFIX + handle);
      var n = raw ? Number(raw) : 0;
      return isNaN(n) ? 0 : n;
    } catch (e) {
      return 0;
    }
  }

  function writeFurthest(handle, index) {
    try {
      window.localStorage.setItem(FURTHEST_PREFIX + handle, String(index));
    } catch (e) {
      /* stil: furthest is een gemak, geen voorwaarde */
    }
  }

  function clearFurthest(handle) {
    try {
      window.localStorage.removeItem(FURTHEST_PREFIX + handle);
    } catch (e) {}
  }

  function readCompleted(root) {
    var el = root.querySelector('[data-cw-completed]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent).filter(function (s) { return s && s.length; });
    } catch (e) {
      return [];
    }
  }

  /* I5-fix (ruling): bij hervatten is de VERST afgeronde stap bepalend, en
     die telt anders per steptype.

     step_personalise heeft precies één uitkomst: na één toevoeging is de
     stap echt klaar, dus daar gaan we voorbij (net als voorheen — de eerste
     nog-niet-afgeronde/overgeslagen stap wordt de starstap).

     step_tiles en step_accessories zijn meerkeuzestappen: één tegel
     toevoegen maakt de cart-regel "afgerond", maar de shopper was
     misschien nog aan het kiezen. Springen we daar dan alsnog voorbij (naar
     de volgende stap), dan kan hij nooit meer terug — v1 is voorwaarts-
     only. Is de verst afgeronde stap dus tegels of accessoires, dan landen
     we ÓP die stap terug, met de al toegevoegde kaarten zichtbaar, in
     plaats van eroverheen te schieten. */
  function resolveStartStep(root, completed, skipped) {
    var all = steps(root);

    var furthestCompletedIndex = -1;
    var furthestCompletedType = null;
    for (var j = 0; j < all.length; j++) {
      var completedType = all[j].dataset.cwStep;
      if (completed.indexOf(completedType) === -1) continue;
      var completedIndex = Number(all[j].dataset.cwIndex);
      if (completedIndex > furthestCompletedIndex) {
        furthestCompletedIndex = completedIndex;
        furthestCompletedType = completedType;
      }
    }

    if (furthestCompletedType === 'step_tiles' || furthestCompletedType === 'step_accessories') {
      return furthestCompletedIndex;
    }

    for (var i = 0; i < all.length; i++) {
      var type = all[i].dataset.cwStep;
      if (completed.indexOf(type) === -1 && skipped.indexOf(type) === -1) {
        return Number(all[i].dataset.cwIndex);
      }
    }
    return all.length ? Number(all[all.length - 1].dataset.cwIndex) : 1;
  }

  /* Autopictura voegt een eigen input[name="id"] toe met een verouderde
     variant-ID. Zonder deze guard wint die van de onze en belandt de
     verkeerde variant in de winkelwagen. Zelfde aanpak als op de PDP
     (sections/product.liquid ~828). */
  function guardVariantInput(form) {
    var own = form.querySelector('input[name="id"]');
    if (own) own.setAttribute('data-theme-variant-input', '');

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'INPUT' && node.name === 'id' &&
              !node.hasAttribute('data-theme-variant-input')) {
            node.remove();
            return;
          }
          if (node.querySelectorAll) {
            Array.prototype.forEach.call(
              node.querySelectorAll('input[name="id"]:not([data-theme-variant-input])'),
              function (el) { el.remove(); }
            );
          }
        });
      });
    });

    observer.observe(form, { childList: true, subtree: true });
  }

  /* De app laadt van een externe CDN. Blokkeert een adblocker die, dan mag
     de wizard niet stilvallen: na 6 seconden zonder gerenderde editor tonen
     we een link naar de gewone PDP. Een trage (niet-geblokkeerde) app kan
     na die 6 seconden alsnog laden — dan hoort de melding weer te
     verdwijnen, dus blijven we de mount ook ná het tonen in de gaten
     houden. */
  function watchPersoMount(step) {
    var mount = step.querySelector('[data-autopictura-block]');
    var fallback = step.querySelector('[data-cw-perso-fallback]');
    if (!mount || !fallback) return;

    var shown = false;

    window.setTimeout(function () {
      if (!mount.children.length) {
        fallback.hidden = false;
        shown = true;
      }
    }, 6000);

    var observer = new MutationObserver(function () {
      if (shown && mount.children.length) {
        fallback.hidden = true;
        shown = false;
      }
    });
    observer.observe(mount, { childList: true });
  }

  /* Submit blijft dicht tot er een ontwerp gekozen is. Autopictura zet de
     waarde van zijn eigen input[name="ai_generation_selected"] via de
     value-PROPERTY (niet via setAttribute) — een MutationObserver met
     attributeFilter: ['value'] ziet zo'n wijziging niet, want attribuut en
     property lopen uit de pas zodra JS de property zet zonder de
     HTML-attribuutwaarde bij te werken. Daarom, net als op de PDP
     (sections/product.liquid ~858), een interval om de waarde te lezen.

     ÉÉN functie (applyGateState) beslist of de knop klikbaar is. Zowel de
     poll hieronder als de fout-afhandeling in initPersoForm roepen die
     aan via het teruggegeven object — er mogen geen twee plekken zijn die
     het onderling oneens kunnen zijn over de status van de knop.

     De poll is begrensd: MAX_TICKS × 300ms ≈ 60s, ruim boven de 6s waarop
     de terugvalmelding al verschijnt. Laadt de app nooit (adblocker,
     CDN-storing, verwijderde app), dan stopt de poll na die 60s vanzelf;
     de knop blijft dan disabled en de terugvalmelding is de uitweg voor
     de shopper — dat is het juiste eindresultaat, geen bug. */
  function gateOnDesignSelection(form, root) {
    var submitBtn = form.querySelector('[data-cw-perso-submit]');
    if (!submitBtn) return null;

    function isDesignSelected() {
      var input = form.querySelector('input[name="ai_generation_selected"]');
      return !!input && input.value === 'true';
    }

    function applyGateState(isSelected) {
      /* RONDE C: alleen nog disabled, het label blijft "Add to cart". */
      if (isSelected) {
        submitBtn.removeAttribute('disabled');
      } else {
        submitBtn.setAttribute('disabled', 'disabled');
      }
      return isSelected;
    }

    /* Direct al vastleggen en dichtzetten — geen gat van 300ms waarin de
       knop nog aanklikbaar zou zijn vóórdat de eerste poll geweest is. */
    var lastState = applyGateState(false);

    var MAX_TICKS = 200; // 200 × 300ms ≈ 60s
    var ticks = 0;

    var poll = window.setInterval(function () {
      ticks += 1;

      var isSelected = isDesignSelected();
      if (isSelected !== lastState) lastState = applyGateState(isSelected);

      if (ticks >= MAX_TICKS) window.clearInterval(poll);
    }, 300);

    /* Gate niet langer nodig zodra de tegel in de cart ligt: geen tweede
       submit meer mogelijk vanaf deze stap. */
    form.addEventListener('cw:added', function () {
      window.clearInterval(poll);
    });

    return {
      /* Herstel de knopstatus naar wat de gate zegt dat hij moet zijn —
         gebruikt door de fout-afhandeling in initPersoForm, zodat een
         mislukte cart-add de knop nooit blind weer vrijgeeft zonder de
         ontwerp-status te herchecken. */
      reapply: function () {
        lastState = applyGateState(isDesignSelected());
      }
    };
  }

  /* Het personalisatieformulier gaat via FormData en niet via het JSON-pad
     van addToCart(): Autopictura heeft er zijn eigen verborgen velden in
     gezet (generatie-ID, ai_generation_selected) en die moeten allemaal mee.
     Een zelf samengesteld object zou ze laten vallen en de bestelling zou
     zonder ontwerp binnenkomen. */
  function initPersoForm(form, root, gate) {
    var submitBtn = form.querySelector('[data-cw-perso-submit]');
    var errorEl = form.querySelector('[data-cw-error]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.dataset.cwBusy === 'true') return;

      form.dataset.cwBusy = 'true';
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

      fetch(CART + '/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (r.ok) return r.json();
          return r.json().then(function (data) {
            var err = new Error('cart-add-failed');
            err.description = data && data.description;
            throw err;
          });
        })
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: { cart: cart }, bubbles: true
          }));
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
          /* M3: dataset.cwLabelAnnounceProduct bevat de aankondiging mét
             de titel van het paginaproduct, zodat deze tekst afwijkt van
             de kaart-aankondigingen (andere producten) en van een
             eventuele herhaling. */
          announce(root, root.dataset.cwLabelAnnounceProduct || root.dataset.cwLabelAnnounce);
          /* Vanaf het formulier dispatchen, niet vanaf root: de listener in
             Task 4 zoekt met e.target.closest('[data-cw-step]') welke stap
             klaar is. */
          form.dispatchEvent(new CustomEvent('cw:added', { bubbles: true }));
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = err.description || root.dataset.cwLabelFailed;
            errorEl.hidden = false;
          }
          /* Niet blind weer vrijgeven: de gate is de enige plek die weet
             of er een ontwerp gekozen is. Zonder gate (geen submit-knop
             gevonden bij het opzetten) valt terug op gewoon vrijgeven. */
          if (gate) {
            gate.reapply();
          } else if (submitBtn) {
            submitBtn.removeAttribute('disabled');
          }
        })
        .then(function () {
          form.dataset.cwBusy = 'false';
        });
    });
  }

  function boot() {
    var root = document.querySelector('[data-campaign-wizard]');
    if (!root) return;

    /* Vóór initCard lezen: elke kaart matcht zichzelf tegen deze lijst om
       meteen als toegevoegd te tonen als de cart al een regel voor 'm
       heeft. */
    var cartLines = readCartLines(root);

    initQty(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-cw-rail]'), initRail);

    Array.prototype.forEach.call(root.querySelectorAll('[data-cw-card]'), function (card) {
      initCard(card, root, cartLines);
    });

    var persoForm = root.querySelector('#cw-personalise-form');
    if (persoForm) {
      guardVariantInput(persoForm);
      initPersoVariant(persoForm);
      var gate = gateOnDesignSelection(persoForm, root);
      initPersoForm(persoForm, root, gate);
    }

    var all = steps(root);

    all.forEach(function (step) {
      if (step.dataset.cwStep === 'step_personalise') {
        watchPersoMount(step);
        initPersoAgain(step);
      }
    });

    /* RONDE D: terug van "Add another personal tile". */
    var againRequested = consumeAgainParam();
    var persoStep = root.querySelector('[data-cw-step="step_personalise"]');

    /* RONDE 2: terug-knoppen aanklikbaar maken. Geen busy-guard nodig —
       stapwisselen zelf doet geen netwerk-call, alleen add/remove op een
       kaart doen dat. */
    Array.prototype.forEach.call(root.querySelectorAll('[data-cw-back]'), function (back) {
      var step = back.closest('[data-cw-step]');
      if (!step) return;
      back.addEventListener('click', function () {
        goToStep(root, Number(step.dataset.cwIndex) - 1, true);
      });
    });

    /* RONDE 2: voortgangsknoppen. disabled (native HTML-attribuut, zie het
       RONDE 2-blok bovenin de sectie) vangt klikken op een nog niet
       bereikte stap al af vóórdat deze listener ooit vuurt — dat is
       precies waarom er hier geen aparte disabled-check meer nodig is. */
    Array.prototype.forEach.call(root.querySelectorAll('[data-cw-progress-button]'), function (btn) {
      btn.addEventListener('click', function () {
        goToStep(root, Number(btn.dataset.cwProgressButton), true);
      });
    });

    var handle = root.dataset.campaignHandle;
    var completed = readCompleted(root);

    /* RONDE C: ligt de gepersonaliseerde tegel al in de cart (herladen,
       terugkomen), dan start de ontwerpstap in de toegevoegd-stand. Vóór
       de eerste refreshActions-doorloop, anders flitst de link. */
    if (completed.indexOf('step_personalise') !== -1) {
      if (againRequested) {
        /* Er ligt al een fototegel in de cart: formulier staat open voor een
           volgende, maar de stap telt als gedaan (verder-knop i.p.v. de
           "doorgaan zonder fototegel"-link). */
        if (persoStep) persoStep.dataset.cwPersoHas = 'true';
      } else {
        setPersoAdded(persoStep);
      }
    }

    /* Doorgaan naar de volgende stap, of afronden op de laatste. Een stap
       zonder toevoegingen telt als overgeslagen (voor hervatten). */
    function advance(step) {
      if (!stepHasAdditions(step)) writeSkip(handle, step.dataset.cwStep);

      if (step.hasAttribute('data-cw-last')) {
        finish(root);
        return;
      }
      goToStep(root, Number(step.dataset.cwIndex) + 1, true);
    }

    all.forEach(function (step) {
      refreshActions(step);

      var next = step.querySelector('[data-cw-next]');
      var skip = step.querySelector('[data-cw-skip]');
      if (next) next.addEventListener('click', function () { advance(step); });
      if (skip) skip.addEventListener('click', function () { advance(step); });
    });

    /* RONDE C: geen auto-doorgaan meer na de gepersonaliseerde tegel. Een
       toevoeging op de ontwerpstap zet die stap in de toegevoegd-stand; een
       toevoeging of verwijdering op elke stap kan knop ↔ link wisselen. */
    root.addEventListener('cw:added', function (e) {
      var step = e.target.closest ? e.target.closest('[data-cw-step]') : null;
      if (step && step.dataset.cwStep === 'step_personalise') setPersoAdded(step);
      all.forEach(refreshActions);
    });
    root.addEventListener('cw:removed', function () {
      all.forEach(refreshActions);
    });

    /* Geen wizard-regels meer in de cart (leeggemaakt, of een nieuwe
       sessie): dan zijn ook de opgeslagen skips én de opgeslagen furthest
       niet meer geldig. Anders zou de wizard stap 3 tonen bij een leeg
       mandje, of een allang niet meer bereikte stap weer vrijgeven. */
    if (!completed.length) {
      clearSkips(handle);
      clearFurthest(handle);
    }

    var skipped = readSkips(handle);

    /* I4: moveFocus=false — dit is de initiële weergave/hervatting na
       herladen, geen door de klant veroorzaakte stapwissel. Anders
       scrollde elke landing op de pagina meteen voorbij de hero naar de
       wizard. goToStep() zet hier ook meteen cwFurthest en de bijbehorende
       voortgangsknoppen vrij tot en met de hervatte stap.

       RONDE B: de landingsstap zelf komt nog steeds uit resolveStartStep
       (cart-gedreven — server-side, kan niet uit de pas lopen). Maar
       cwFurthest zelf leefde tot nu toe alleen in het DOM-dataset en dus
       nergens ná een herlaadpagina: Math.max(readFurthest(handle),
       landingIndex) zorgt dat een stap die de shopper al eerder bereikte
       (bv. via de voortgangsknoppen, zonder 'm per se af te ronden) na een
       refresh niet opnieuw op slot staat. */
    if (all.length) {
      var landingIndex = resolveStartStep(root, completed, skipped);
      var startIndex = Math.max(readFurthest(handle), landingIndex);
      /* Klem op all.length: een opgeslagen furthest kan in theorie voorbij
         het huidige aantal stappen wijzen (merchant heeft sindsdien een
         blok verwijderd) — zonder klem zou goToStep een index krijgen die
         geen enkele stap matcht en dus alles hidden laat staan. */
      startIndex = Math.min(startIndex, all.length);

      /* RONDE D: bewust terug naar de ontwerpstap voor een tweede tegel.
         moveFocus=true: de shopper klikte zelf, dus meteen naar de wizard. */
      goToStep(root, startIndex, false);
      /* Eerst de normale hervat-stap (zet cwFurthest, zodat al bereikte
         stappen in de voortgang klikbaar blijven), dan pas terug. */
      if (againRequested && persoStep) {
        goToStep(root, Number(persoStep.dataset.cwIndex), true);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-campaign-wizard]')) boot();
  });
})();
